import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20home%20theater%20setup%20with%20large%20screen%20displaying%20vibrant%20film%20scene%2C%20warm%20ambient%20golden%20lighting%2C%20comfortable%20atmosphere%2C%20dark%20background%20with%20subtle%20glow%2C%20elegant%20interior%20design%2C%20movie%20night%20aesthetic&width=1600&height=900&seq=hero-bg-main-01&orientation=landscape"
        alt="白云视频 - 免费高清在线影视平台"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full text-center px-4">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            海量影视 免费观看
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
            高清不卡顿，随时随地享受精彩内容
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/category/movie"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 flex items-center gap-2"
            >
              <i className="ri-play-fill text-lg"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-white/20 hover:bg-white/30 text-white rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 backdrop-blur-sm border border-white/30"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 md:gap-10 mt-10 flex-wrap">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">5000+</p>
              <p className="text-xs text-white/60 mt-1">高清影片</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">300万+</p>
              <p className="text-xs text-white/60 mt-1">日活用户</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">99.9%</p>
              <p className="text-xs text-white/60 mt-1">播放成功率</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}